import React from "react";
import styled from "styled-components";
import { GroupAsset } from "@domain/group/group";
import { formatBytes } from "@domain/media/utils";
import { Clamp } from "@ui/components/containers/clamp";
import { RoundedBlock } from "@ui/components/containers/roundedBlock";
import { PdfIcon } from "@ui/components/icons";
import { Stack, row } from "@ui/components/layout";

interface ShareroomPdfThumbnilProps extends React.HTMLAttributes<HTMLDivElement> {
	workspace: GroupAsset;
}
export const ShareroomPdfThumbnil: React.FC<ShareroomPdfThumbnilProps> = ({ onClick, workspace, ...htmlProps }) => {
	return (
		<Container {...htmlProps}>
			<Content data-asset="true" onClick={onClick}>
				<TopSide>
					<Stack gap={0} align="center" justify="flex-end">
						<BigIconWrapper>
							<PdfIcon />
						</BigIconWrapper>
					</Stack>
				</TopSide>
				<BottomSide size={1}>{workspace?.asset.displayName}</BottomSide>
				{workspace?.asset?.size && <Size>{formatBytes(workspace?.asset?.size)}</Size>}
			</Content>
		</Container>
	);
};

const Container = styled.div`
	position: relative;
`;

const Content = styled(RoundedBlock)`
	cursor: zoom-in;
	overflow: hidden;
	position: relative;
`;
const TopSide = styled.div`
	height: 90px;

	> div {
		height: 100%;
	}
`;

const BottomSide = styled(Clamp)`
	padding: 30px 10px 0;
	word-break: break-all;
	${({ theme }) => theme.textStyles.text};
	text-align: center;
	margin-bottom: 3px;
`;

const Size = styled.div`
	${({ theme }) => theme.textStyles.small};
	color: ${({ theme }) => theme.colors.textSecondary};
	margin-bottom: 10px;
	padding-left: 10px;
`;

const BigIconWrapper = styled.div`
	width: 50px;
	height: 50px;
	border-radius: 25px;
	${row(0, "center", "center")};
	background-color: ${({ theme }) => theme.colors.secondaryLight};
	svg {
		width: 23px;
		height: 23px;
		path {
			fill: ${({ theme }) => theme.colors.secondary};
		}
	}
`;
